import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import * as Repository from "../repository";
import { DesignMagazineSettingTagPresenter } from "./presenter";

type onFinishCallbackProps = {
	tagList: Array<string>;
	regionTag?: string;
	prefectureTag?: string;
	cityTag?: string;
};
type Props = {
	tagList?: Array<string>;
	regionTag?: string;
	prefectureTag?: string;
	cityTag?: string;
	//
	open: boolean;
	onOpenChange: (open: boolean) => void;
	//
	onFinishCallback: (props: onFinishCallbackProps) => void;
};

export const DesignMagazineSettingTagContainer = (props: Props) => {
	const { magazineTagQueryData } = Repository.Query.UseCase.useMagazineTagQuery();

	if (!magazineTagQueryData) {
		notifyUserEventInfo({
			title: "タグのデータが取得できませんでした",
		});
		return null;
	}

	return <DesignMagazineSettingTagPresenter {...props} magazineTagQueryData={magazineTagQueryData} />;
};
